import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getSelectableRecordGroups } from '../api/recordGroupApi'

export function useSelectableRecordGroups(enabled = true) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['record-groups', 'selectable', i18n.language],
    queryFn: getSelectableRecordGroups,
    enabled,
  })
}
